//React
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
//Components
import Header from "../../components/Header/Header";
import PatientList from "../../components/PatientList/PatientList";
import SelectShoulder from "../../components/SelectShoulder/SelectShoulder";
import Survey from "../../components/Survey/Survey";
import Image from "../../components/Image/Image";
import Result from "../../components/Result/Result";
//Assets
import AccountCircleIcon from "../../assets/images/AccountCircle.svg";
//Components
import ProgressBar from "../../components/ProgressBar/ProgressBar";
//CSS
import "./Main.css";
import SecureLocalStorage from "react-secure-storage";
const Main = () => {
  const location = useLocation();
  const doctorId = SecureLocalStorage.getItem("doctorId");
  const [createdPatientCode, setCreatedPatientCode] = useState(
    location.state?.createdPatientCode ||
      SecureLocalStorage.getItem("createdPatientCode")
  );
  const [step, setStep] = useState("shoulder");
  const [progressWidth, setProgressWidth] = useState(1);
  const [progressCurrent, setProgressCurrent] = useState(1);
  const [selectedLeftShoulder, setSelectedLeftShoulder] = useState(false);
  const [selectedRightShoulder, setSelectedRightShoulder] = useState(false);
  const [leftSurvey, setLeftSurvey] = useState(null);
  const [rightSurvey, setRightSurvey] = useState(null);
  const [leftImageData, setLeftImageData] = useState(null);
  const [rightImageData, setRightImageData] = useState(null);
  const [result, setResult] = useState(null);
  const [tempResult, setTempResult] = useState(null);
  const [apiLoading, setApiLoading] = useState(false);

  // location.state에 createdPatientCode가 있으면 step을 shoulder로 리셋
  useEffect(() => {
    if (location.state?.createdPatientCode) {
      setStep("shoulder");
      setCreatedPatientCode(location.state.createdPatientCode);
      // 상태 초기화
      setSelectedLeftShoulder(false);
      setSelectedRightShoulder(false);
      setLeftSurvey(null);
      setRightSurvey(null);
      setLeftImageData(null);
      setRightImageData(null);
      setResult(null);
      setTempResult(null);
    }
  }, [location.state?.createdPatientCode]);

  useEffect(() => {
    switch (step) {
      case "shoulder":
        setProgressWidth(1);
        setProgressCurrent(1);
        break;
      case "survey":
        setProgressWidth(33);
        setProgressCurrent(2);
        break;
      case "image":
        setProgressWidth(66);
        setProgressCurrent(3);
        break;
      case "result":
        setProgressWidth(66);
        setProgressCurrent(3);
        break;
      default:
        setProgressWidth(1);
    }
  }, [step]);

  const renderContent = () => {
    switch (step) {
      case "shoulder":
        return (
          <SelectShoulder
            setProgressWidth={setProgressWidth}
            selectedLeftShoulder={selectedLeftShoulder}
            selectedRightShoulder={selectedRightShoulder}
            setSelectedLeftShoulder={setSelectedLeftShoulder}
            setSelectedRightShoulder={setSelectedRightShoulder}
            onNext={() => setStep("survey")}
          />
        );
      case "survey":
        return (
          <Survey
            setProgressWidth={setProgressWidth}
            leftShoulder={selectedLeftShoulder}
            rightShoulder={selectedRightShoulder}
            leftSurvey={leftSurvey}
            rightSurvey={rightSurvey}
            setLeftSurvey={setLeftSurvey}
            setRightSurvey={setRightSurvey}
            onNext={() => setStep("image")}
            onBack={() => setStep("shoulder")}
          />
        );
      case "image":
        return (
          <Image
            setProgressWidth={setProgressWidth}
            leftShoulder={selectedLeftShoulder}
            rightShoulder={selectedRightShoulder}
            leftImageData={leftImageData}
            rightImageData={rightImageData}
            setLeftImageData={setLeftImageData}
            setRightImageData={setRightImageData}
            doctorId={doctorId}
            leftSurvey={leftSurvey}
            rightSurvey={rightSurvey}
            apiLoading={apiLoading}
            setApiLoading={setApiLoading}
            result={result}
            setResult={setResult}
            onNext={() => setStep("result")}
            onBack={() => setStep("survey")}
          />
        );
      case "result":
        return (
          <Result
            result={result}
            setResult={setResult}
            tempResult={tempResult}
            setTempResult={setTempResult}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="main">
      <Header />
      <div className="main-container">
        <PatientList
          step={step}
          setStep={setStep}
          onPatientCreated={(createdPatientCode) => {
            setStep("shoulder");
            setCreatedPatientCode(createdPatientCode);
            // 상태 초기화
            setSelectedLeftShoulder(false);
            setSelectedRightShoulder(false);
            setLeftSurvey(null);
            setRightSurvey(null);
            setLeftImageData(null);
            setRightImageData(null);
            setResult(null);
            setTempResult(null);
          }}
        />
        <div className="home-container">
          <div className="patient-info-container">
            <AccountCircleIcon alt="account-circle" />
            <div className="patient-code">{createdPatientCode}</div>
          </div>
          <div
            className="container"
            style={{
              padding: result ? "0px 0px 30px 0px" : "30px 50px",
              height: "100%",
            }}
          >
            {!apiLoading && result === null && (
              <div className="progress-container">
                <ProgressBar
                  width={progressWidth}
                  current={progressCurrent}
                  total={3}
                />
              </div>
            )}
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Main;
